/**
 * /frontend/src/features/analytics/components/offers/OfferSummaryKPIs.js
 */

import React from 'react';
import KPICardRow from '../shared/KPICardRow';
import KPICard from '../shared/KPICard';
import { formatCurrencyInr, formatPercent } from '../../utils/formatters';

/**
 * Offer analytics summary KPIs.
 * @param {{summary:any}} props
 * @returns {JSX.Element}
 */
const OfferSummaryKPIs = ({ summary }) => (
  <KPICardRow>
    <KPICard label="Views" value={Number(summary?.totalViews || 0).toLocaleString('en-IN')} />
    <KPICard label="Claims" value={Number(summary?.totalClaims || 0).toLocaleString('en-IN')} />
    <KPICard label="Redemptions" value={Number(summary?.totalRedemptions || 0).toLocaleString('en-IN')} />
    <KPICard label="Engagement" value={formatPercent(summary?.overallEngagementRate)} />
    <KPICard label="Redemption rate" value={formatPercent(summary?.overallRedemptionRate)} />
    <KPICard label="Discount cost" value={formatCurrencyInr(summary?.totalEstimatedDiscountCost)} />
  </KPICardRow>
);

export default OfferSummaryKPIs;
